import React from 'react';

const Header = () =>
    <header className="clearfix">
        <div className="title col-xs-12 col-sm-offset-1 col-sm-8 col-md-offset-3 col-md-6 col-lg-5">
            <h1>Chris Lindeman</h1>
        </div>
    </header>

export default Header;
